import BlockComponent from "../BlockComponent";

import React, { useCallback, useEffect, useState } from "react";
import PalmaresBlock from "./PalmaresBlock";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import palmares from "@data/palmares";

const Palmares: React.FC = () => {
  const [emblaRef, embla] = useEmblaCarousel({ skipSnaps: false, loop: true }, [Autoplay({ delay: 3000 })]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  // const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  // const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
  // const scrollTo = useCallback((index) => embla && embla.scrollTo(index), [embla]);

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    // setPrevBtnEnabled(embla.canScrollPrev());
    // setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on("select", onSelect);
  }, [embla, setScrollSnaps, onSelect]);

  return (
    <BlockComponent titre="Notre palmarès">
      <div id="palmares-container" className="flex flex-col items-center">
        <div id="palmares-grid" className="grid w-full grid-cols-2 gap-4 xl:grid-cols-4">
          {palmares.map((palm, key) => (
            <PalmaresBlock key={key} titre={palm.titre} placement={palm.placement} imageCompetition={palm.imageCompetition} />
          ))}
        </div>
        <div className="mt-4 flex w-full justify-end">
          <a
            href="https://liquipedia.net/rainbowsix/DeathroW"
            rel="noreferrer noopener"
            target="_blank"
            title="Page liquipedia de DeathroW"
            aria-label="Aller sur la page du club"
            className="group inline-flex items-center text-xs font-semibold uppercase tracking-wider text-redAccent"
          >
            Voir la page Liquipedia
            <svg
              className="ml-2 inline-block w-3 transform transition duration-500 ease-in-out group-hover:translate-x-1 group-focus:translate-x-1"
              fill="currentColor"
              viewBox="0 0 12 12"
            >
              <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
            </svg>
          </a>
        </div>
      </div>
    </BlockComponent>
  );
};

export default Palmares;
